// extracted by mini-css-extract-plugin
export default {"buttonResetContainer":"ButtonReset_buttonResetContainer__EBsl5","button":"ButtonReset_button__sqRya"};